import { SET_CODE } from "../constants";

const code = (state = null, action) => {
  switch (action.type) {
    case SET_CODE:
      return typeof action.code === "string" ? action.code.trim() : null;
    default:
      return state;
  }
};

export default code;



// WEBPACK FOOTER //
// ./src/reducers/code.js